
    <div class="company container container-extra">

        <app-back-nav class="mb-20" linkText="Vissza az admin oldalra"></app-back-nav>

        <section class="page-title">
            <h1>Cég</h1>
        </section>
  
        <mat-card class="p-24">
            <mat-card-content class="person-block p-0">

                <div>
                    <button mat-flat-button color="primary" (click)="calculateResults()" *ngxPermissionsOnly="['SuperAdmin']">
                        <mat-icon>list_alt_add</mat-icon> Panoráma eredmény kalkuláció
                    </button>
                </div>

            </mat-card-content>
        </mat-card>

    </div>
